import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class Alain extends React.Component {
  render() {
    
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
                    <section id="alain-section">
                        <img className="alain_header_bg" src="images/alain_header_bg-200.png"/>
                        <img className="alain_footer_bg" src="images/alain_footer_bg-200.png"/>
                        <img className="alain_mobile_footer_bg1 mob-disp" src="images/alain_mobile_footer_bg1.png"/>
                        <img className="alain_mobile_header_bg1 mob-disp" src="images/alain_mobile_header_bg1.png"/>
                        <div className="container">
                          <div className="row">
                            <div className="col-md-4 col-xs-12 alain-img">
                              <img src="images/img-alain.png"/>
                            </div>
                            <div className="col-md-8 col-xs-12">
                              <div className="head-part" class="text-center">
                                <h3>{t('alaintitle')}</h3>
                                <p>{t('alainpara1')}</p>
                                <p>{t('alainpara2')}</p>
                                <p>{t('alainpara3')}<b classname="bold">{t('alainpara3bold')}</b>{t('alainpara4')}</p>
                              </div>
                            </div>
                          </div>
                   
                        <div className="row">
                            <div className="col-md-12 col-xs-12">
                              <div className="content-part">
                                <h4><i>{t('learntitle')}</i></h4>
                                <p><b className="bold">{t('learnbold')}</b>{t('learnl1')}</p>
                                <p><b className="bold">{t('learnbold2')}</b>{t('learnl2')} </p>
                                <p>{t('learnl3')}<b className="bold">{t('learnbold3')}</b></p>
                                <p>{t('learnl4')}</p>
                                <p>{t('learnl5')}<b className="bold">{t('learnbold5')}</b>{t('learnl6')}</p>
                                <p>{t('learnl7')}<b>{t('learnbold7')}</b>
                                <div>{t('learnl8')} <b className="bold">{t('learnbold8')}</b></div></p>
                                <p>{t('learnl9')}</p>
                                <p>{t('learnl10')} <b className="bold">{t('learnbold10')} </b>{t('learnl11')}</p>
                              </div>
                            </div>
                          </div>
                          <div className="row" id="card-alain">
                            <div className="card-alain-col">
                            <a href="http://www.winemosaic.org/it/team/alain-carbonneau/" target="_blank">
                              <img className="card-alain-img" src="images/card_alain_01.png"/>
                              <h5 className="single-text">{t('learnimg1')}</h5>
                              <img className="red-arrow" src="images/ic-arrow_white.png"/>
                            </a>
                            </div>
                            <div className="card-alain-col">
                            <a href="https://www.dunod.com/livres-alain-carbonneau" target="_blank">
                              <img className="card-alain-img" src="images/card_alain_02.png"/>
                              <h5>{t('learnimg2')}<br/>{t('learnimgl2')}</h5> 
                              <img className="red-arrow" src="images/ic-arrow_white.png"/>
                           </a>
                            </div>
                            <div className="card-alain-col">
                            <a href="http://www.quae.com/fr/r5056-de-l-%C5%93nologie-a-la-viticulture.html" target="_blank">
                              <img className="card-alain-img" src="images/card_alain_03.png"/>
                              <h5>{t('learnimg3')} <br/>{t('learnimgl3')}</h5>
                              <img className="red-arrow" src="images/ic-arrow_white.png"/>
                            </a>
                            </div>
                          </div>
                        </div>
                      </section>
                    )
                }
            </I18n>
         ) 
     }
}


// WEBPACK FOOTER //
// ./src/components/Propos/Alain/Alain.js